module.exports = __webpack_public_path__ + "6737878795fab44fba7410b3d8f2ff11.svg";